export const draftPicksByYearQuery = `
query($year: Int){
	draftPicks(year: $year){
    year
    round
    roundPick
    overallPick
    teamId
    playerName
    college
    position
  }
}
`